import { useState } from 'react';

const faqs = [
  {
    q: '这个恋爱后宫聚合页适合什么样的读者？',
    a: '适合喜欢恋爱、后宫题材的读者，无论是偏爱校园青涩纯爱、温馨同居日常，还是享受暧昧拉扯与逆后宫多CP抉择，都能在这里按分类找到对应作品。',
  },
  {
    q: '校园、同居、暧昧、逆后宫四种分类有什么区别？',
    a: '校园系主打青春慢热与纯爱氛围；同居系聚焦同处一屋檐下的温馨升温；暧昧系更偏成年向的克制与推拉张力；逆后宫则以一位女主角被多位男主围绕、需要做出抉择为核心看点。',
  },
  {
    q: '为什么推荐里会标注评分和连载话数？',
    a: '评分反映站内漫迷的综合口碑，连载话数则帮助你判断作品的长短与更新进度，两者结合可以更理性地决定是否入坑，减少踩雷和追更中断的困扰。',
  },
  {
    q: '这里的作品会持续更新吗？',
    a: '会。我们会持续按剧情类型整理和补充新的恋爱后宫作品，并结合读者反馈调整分类与推荐排序，确保聚合页保持新鲜与实用。',
  },
  {
    q: '如何在站内快速找到想看的具体题材？',
    a: '可以先使用首屏下方的分类筛选，再通过每部作品的标签缩小范围；也可以参考人气排行榜，从口碑作品开始入手，逐步找到符合自己口味的类型。',
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-semibold text-primary-700">
            <i className="ri-question-line" />
            常见问题
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            你想了解的都在这里
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? 'border-primary-200 bg-background-50' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-base font-semibold text-foreground-950 md:text-lg">
                    {item.q}
                  </h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      open ? 'rotate-180 bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" />
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:text-base">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}